import { cn } from '@spiaggeit/spit-ui'
import { AppIcon, Icon } from '@/assets/icons'
import { useAppSelector } from '@/hooks/store'
import { appSlice } from '@/store/appSlice'

interface SurfaceIconProps {
  iconName: AppIcon
}

export function SurfaceIcon(props: SurfaceIconProps) {
  const isPool = useAppSelector(appSlice.selectors.isPool)

  return (
    <div className="flex justify-center">
      <div
        className={cn('rounded-circle p-2.5', {
          'bg-blue-500 text-white shadow-[0_0_0_6px_var(--blue-100)]': isPool,
          'bg-yellow-100 text-yellow-300 shadow-[0_0_0_6px_var(--yellow-50)]':
            !isPool,
        })}
      >
        <Icon className="size-5" name={props.iconName} />
      </div>
    </div>
  )
}
